import Lottie from "lottie-react";
import loaderAnimation from "@/assets/lottieAnimations/Compi Empty.json";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

const CompetitorsEmpty = ({ className }: Props) => {
  return (
    <div className="flex flex-col gap-4 items-center justify-center h-full w-full">
      <div className={cn("w-[169px]", className)}>
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className="flex flex-col items-center gap-[14px]">
        <div className="text-center">
          <p className="overflow-hidden text-brand-primary-new text-center text-ellipsis text-[13px] font-medium leading-[19.157px] tracking-[0.26px]">
            All quiet on these dates
          </p>
          <p className="overflow-hidden text-brand-primary-600 text-center text-ellipsis text-[12px] font-normal leading-[16px] tracking-[0.24px]">
            Try a broader range or pick different dates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompetitorsEmpty;
